import React from "react";
import AsideBar from "./AsideBar/AsideBar";
import Footer from "./small/Footer";
import TabProduct from "./Tab/TabProduct";
import TechRobotBanner from "./Tech Robot/TechRobotBanner";
import { Icon } from "@iconify/react";
const Collectionexpand = () => {
  return (
    <div>
      <TechRobotBanner forImage="../../assets/images/collectionexpand/collectionexpand.png" />

      <section className="project-content nft-detail-bg">
        <div className="container-fluid p-0">
          <div className="row" style={{ marginRight: "0" }}>
            <div id="filter-col" className="col-md-1 pe-0  col-2 ">
              <AsideBar />
            </div>
            <div id="card-col" className="col-md-10 ps-0  col-10 ">
              <TabProduct />
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
};

export default Collectionexpand;
